export const findProductIndexInProducts = (
  product,
  products,
  unique_fields
) => {
  const index = products.findIndex(item =>
    unique_fields.every(field => item[field] === product[field])
  );
  return index;
};
